import { Directive } from "@angular/core";
import { classes } from "@spartan-ng/helm/utils";

/**
 * O2 Sheet Title Directive
 *
 * Title element for the sheet header.
 * Applies consistent styling to sheet titles.
 * Styled with large, bold text.
 *
 * Note: Accessibility is provided by the sheet context.
 *
 * Usage:
 * <h2 o2SheetTitle>{{ title }}</h2>
 */
@Directive({
  selector: "[o2SheetTitle]",
  standalone: true,
})
export class O2SheetTitleDirective {
  constructor() {
    classes(() => "text-2xl font-semibold");
  }
}
